import ouiBase from '@goldwasserexchange/oui';
import { useBondListFieldApiBySAccId } from '../api';

export const useBondListSAccIntRate = () => {
  const sAccId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useBondListFieldApiBySAccId({
    sAccId,
    field: 'S_ACC.INT_RATE',
  });
  return response;
};
